
<script src="https://unpkg.com/vconsole@latest/dist/vconsole.min.js"></script>
<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				macId: '',
				xode: '',
				xtitle: '',
			}
		},
		methods: {
			JsOperationRequest (message) {
			  console.log(JSON.stringify(message));
			  // 将 JSON 字符串解析为 JS 对象（“实体类”）
			  var data = message;
			  var msg="";
			  switch (data.type) {
			   case "bindCode":
				 msg = data.msg;
				 break;
			   case "tvBusinessTrigger":
					//Tv端业务触发
				 msg = data.msg;
				 var businessType = msg.businessType;
				 var action = msg.action;

				break;
			   case "heartbeat":
				 msg = data.msg;
			   //心跳 返回任意值即可
				 break;
			 }
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(msg);
			},
			//带返回值
			 JsOperationCallBack (message) {
			  console.log(JSON.stringify(message));
			  // 将 JSON 字符串解析为 JS 对象（“实体类”）
			  var data = message;
			  var msg="";
			  switch (data.type) {
			   case "heartbeat":
			   //心跳 返回任意值即可

				 break;

			 }
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(data);
			  return "message";
			} ,
			androidCover () {
			  var data = {
				type: "cover",
				msg: {
				  showTvOverlay: true,
				  TvImageUrl: "https://img0.baidu.com/it/u=3217812679,2585737758&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500",
				  OperateScreenUrl: "https://img0.baidu.com/it/u=3217812679,2585737758&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500",
				  OperateScreenPortUrl: "http://gips3.baidu.com/it/u=4283915297,3700662292&fm=3028&app=3028&f=JPEG&fmt=auto?w=1440&h=2560"
				}
			  }
			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  if (window.kdroid && kdroid.STBOperation) {
				let result =kdroid.STBOperation(jsonData);
				document.getElementById("message").innerText = "发送 Android 消息：" + JSON.stringify(result);
			  } else {
				alert("Android 接口不可用！给android 发送数据："+jsonData);
			  }
			},
			androidRemoveCover () {
			  var data = { "msg": "", "type": "removeCover" }
			  var jsonData = JSON.stringify(data);
			  if (window.kdroid && kdroid.STBOperation) {
				let result =kdroid.STBOperation(jsonData);
				document.getElementById("message").innerText = "发送 Android 消息：" + JSON.stringify(result);
			  } else {
				alert("Android 接口不可用，给android 发送数据："+jsonData);
			  }
			} ,
			closeRoom () {
			  // 创建一个JSON对象
			  var data = {
				"type": "closeRoom",
				"msg": ""
			  };
			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  document.getElementById("sendMessage").innerText = "发送 Android 消息：" + JSON.stringify(jsonData);
			  // 通过AndroidBridge接口将JSON数据传递给Android
			  let result =window.kdroid.STBOperation(jsonData);
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(result);
			},
			openRoom () {
			  // 创建一个JSON对象
			  var data = {
				"msg": "",
				"type": "openRoom"
			  };
			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  document.getElementById("sendMessage").innerText = "发送 Android 消息：" + JSON.stringify(jsonData);
			  // 通过AndroidBridge接口将JSON数据传递给Android
			  let result =window.kdroid.STBOperation(jsonData);
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(result);
			},
			getBindCode () {
			  // 创建一个JSON对象
			  var data = {
				"type": "bindCode",
				"mac": "78:12:45:A3:9B:33",
				"msg": ""
			  };
			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  document.getElementById("sendMessage").innerText = "发送 Android 消息：" + JSON.stringify(jsonData);
			  // 通过AndroidBridge接口将JSON数据传递给Android
			  let result = window.kdroid.STBOperation(jsonData);
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(result);
			},
			getScreenOrientation () {
			  // 创建一个JSON对象
			  var data = {
				"msg": "",
				"type": "getScreenOrientation"
			  };
			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  document.getElementById("sendMessage").innerText = "发送 Android 消息：" + JSON.stringify(jsonData);
			  // 通过AndroidBridge接口将JSON数据传递给Android
			  let result = window.kdroid.STBOperation(jsonData);
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(result);
			},
			sendLightCtrl () {
			  const selectElement = document.getElementById('lightCtrl');
			  const selectedValue = selectElement.value;
			  event.preventDefault();
			  // 创建一个JSON对象
			  var data = {
				"msg": selectedValue,
				"type": "lightCtrl"
			  };
			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  document.getElementById("sendMessage").innerText = "发送 Android 消息：" + JSON.stringify(jsonData);
			  // 通过AndroidBridge接口将JSON数据传递给Android
			  let result = window.kdroid.STBOperation(jsonData);
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(result);
			},
			sendAcCtrl () {
			  const selectElement = document.getElementById('acCtrl');
			  const selectedValue = selectElement.value;
			  event.preventDefault();
			  // 创建一个JSON对象
			  var data = {
				"msg": selectedValue,
				"type": "acCtrl"
			  };
			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  document.getElementById("sendMessage").innerText = "发送 Android 消息：" + jsonData;
			  // 通过AndroidBridge接口将JSON数据传递给Android
			  let result = window.kdroid.STBOperation(jsonData);
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(result);
			},
			reboot () {
			  // 创建一个JSON对象
			  var data = {
				"msg": "",
				"type": "reboot"
			  };
			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  document.getElementById("sendMessage").innerText = "发送 Android 消息：" + JSON.stringify(jsonData);
			  // 通过AndroidBridge接口将JSON数据传递给Android
			  let result = window.kdroid.STBOperation(jsonData);
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(result);
			},
			sendHeart() {
			  // 创建一个JSON对象
			  var data = {
			  "type": "heartbeat",
			   "msg": {
						 "time": 1
						}
			  };

			  // 将JSON对象转化为字符串
			  var jsonData = JSON.stringify(data);
			  document.getElementById("sendMessage").innerText = "发送 Android 消息：" + JSON.stringify(jsonData);
			  // 通过AndroidBridge接口将JSON数据传递给Android
			  let result = window.kdroid.STBOperation(jsonData);
			  document.getElementById("message").innerText = "收到 Android 消息：" + JSON.stringify(result); 
			} ,
		},
		mounted() 
		{
			window.scroll(0, 0);
			document.title = '玩美朋友，快乐相聚';
		}
	}
</script> 

<template> 
		<div class='x-elem'>
			<img src="../assets/images/bg.png" class="xbg" />
			<img mode="widthFix" src="../assets/images/wmpy.jpg" class="xlogo" />
			<p class="xtitle">扫码点歌，欢乐无限</p>
			<p id="message" class='xtips'>Allen DEV</p>
			<p id="sendMessage" class='xtips'>深圳摩米贝尔科技有限公司</p>
		</div> 
</template>
 
<style>
    body 
	{
		margin: 0;
		background-color: rgba(239, 239, 239, 0);  
		/**width: 207px;
		height: 285px;*/
		position: relative;
    }  
	.x-elem 
	{
	    width: 100%;
	    height: 100%;
	    display: flex;
	    flex-direction: column;
	    align-items: center;
	    position: absolute;
	    top: 0;
	    left: 0;
	}
	.xbg 
	{
		width: 207px;
		height: 285px;
		object-fit: cover;
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
	}
	.xlogo
	{
		width: 178px;
		height: 178px;
		margin-top: 40px; 
	}
	.xtitle
	{
		font-size: 22px;
		color: #a3631e;
	}
	.xtips
	{
		color: #a3631e;
	}
</style>